export default str => str.split('-')
	.map(
		(part, i) => (
			i > 0
				? part.substr(0, 1).toUpperCase() + part.substr(1)
				: part
		))
	.join('');
